import { ChainId } from '@pancakeswap/chains'
import {
  STABLESWAP_SUBGRAPH_CLIENT,
  V3_SUBGRAPH_URLS,
  INFO_CLIENT_WITH_CHAIN,
  ORDERS_CLIENT_WITH_CHAIN,
  STATS_SUBGRAPH_URLS
} from 'config/constants/endpoints'
import { GraphQLClient } from 'graphql-request'

// Extra headers
// Mostly for dev environment
// No production env check since production preview might also need them
export const getGQLHeaders = (endpoint: string) => {
  // if (endpoint === INFO_CLIENT && process.env.NEXT_PUBLIC_NODE_REAL_HEADER) {
  //   return {
  //     origin: process.env.NEXT_PUBLIC_NODE_REAL_HEADER,
  //   }
  // }
  return undefined
}

export const infoClient = new GraphQLClient(V3_SUBGRAPH_URLS[ChainId.PULSE])

export const infoClientWithChain = (chainId: number) => {
  if (INFO_CLIENT_WITH_CHAIN[chainId]) {
    return new GraphQLClient(INFO_CLIENT_WITH_CHAIN[chainId], {
      headers: getGQLHeaders(INFO_CLIENT_WITH_CHAIN[chainId]),
    })
  }
  return undefined
}

export const ordersClientWithChain = (chainId: number) => {
  return new GraphQLClient(ORDERS_CLIENT_WITH_CHAIN[chainId])
}

export const statsClients = {
  [ChainId.PULSE]: new GraphQLClient(STATS_SUBGRAPH_URLS[ChainId.PULSE]),
}

export const v3Clients = {
  [ChainId.PULSE]: new GraphQLClient(V3_SUBGRAPH_URLS[ChainId.PULSE]),
}

export const v3InfoClients = v3Clients
// export const v2InfoClients = {
//   [ChainId.PULSE]: new GraphQLClient(V3_SUBGRAPH_URLS[ChainId.PULSE])
// }

// export const infoClientETH = new GraphQLClient(INFO_CLIENT_ETH)

export const v2Clients = {
  [ChainId.PULSE]: new GraphQLClient(INFO_CLIENT_WITH_CHAIN[ChainId.PULSE]),
}

export const infoStableSwapClient = new GraphQLClient(STABLESWAP_SUBGRAPH_CLIENT)

export const stableSwapClient = new GraphQLClient(STABLESWAP_SUBGRAPH_CLIENT)

// export const bitQueryServerClient = new GraphQLClient(BIT_QUERY, {
//   headers: {
//     // only server, no `NEXT_PUBLIC` not going to expose in client
//     'X-API-KEY': process.env.BIT_QUERY_HEADER || '',
//   },
//   timeout: 5000,
// })
